import Vue from 'vue';
import Router from 'vue-router';
import main from '@/views/main';
import {reportLog} from '@/js/log.js'
Vue.use(Router);
const router =  new Router({
    mode: 'history',

    routes: [
        {
            path: '/',
            name: 'Main',
            redirect: '/',
            component: main,
            children: [
                {
                    path: '/',
                    name: 'Home',
                    meta: {
                        nav: 'Home'
                    },
                    component: () => import('@/views/home/index')
                },
                {
                    path: '/trainingcouses',
                    name: 'Training couses',
                    meta: {
                        nav: 'Training couses'
                    },
                    component: () => import('@/views/Trainingcouses/index')
                }, {
                    path: '/trainingcouses/info',
                    name: 'Training couses Info',
                    meta: {
                        nav: 'Training couses'
                    },
                    component: () => import('@/views/Trainingcouses/info')
                }, {
                    path: '/trainingcouses/info',
                    name: 'Training couses Info',
                    meta: {
                        nav: 'Training couses'
                    },
                    component: () => import('@/views/Trainingcouses/info')
                }, {
                    path: '/news',
                    name: 'WDCM News',
                    meta: {
                        nav: 'WDCM News'
                    },
                    component: () => import('@/views/news/index')
                }, {
                    path: '/news/info',
                    name: 'WDCM News Info',
                    meta: {
                        nav: 'WDCM News'
                    },
                    component: () => import('@/views/news/info')
                }, {
                    path: '/event',
                    name: 'Events',
                    meta: {
                        nav: 'Events'
                    },
                    component: () => import('@/views/events/index')
                }, {
                    path: '/event/info',
                    name: 'Events Info',
                    meta: {
                        nav: 'Events'
                    },
                    component: () => import('@/views/events/info')
                }, {
                    path: '/projects',
                    name: 'Projects',
                    meta: {
                        nav: 'Projects'
                    },
                    component: () => import('@/views/projects/index')
                }, {
                    path: '/cooperation',
                    name: 'Cooperation',
                    meta: {
                        nav: 'Cooperation'
                    },
                    component: () => import('@/views/cooperation/index')
                }, {
                    path: '/history',
                    name: 'History',
                    meta: {
                        nav: 'History'
                    },
                    component: () => import('@/views/history/history')
                }
            ]
        },
        {
            path: '/photos',
            name: 'photos',
            meta: {
                nav: 'photos'
            },
            component: () => import('@/views/photos.vue')
        },
        {
            path: '/database',
            name: 'database',
            meta: {
                nav: 'database'
            },
            component: () => import('@/views/database.vue')
        }
    ]
});
router.afterEach(()=>{
    reportLog('wdcm')
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js